'use strict';

module.exports = {
  USER: 'user',
  RECOMMENDED: 'recommended',
};
